// Actions
import {
  SET_PROSPECTIVE_STUDENTS_QUERY,
  SET_PARENTS_OF_PROSPECTS_QUERY,
  SET_OTHER_QUERY,
  SET_USA_QUERY,
  SET_INTERNATIONAL_QUERY,
  SET_AGE_QUERY,
  SET_GENDER_QUERY,
  SET_ETHNICITY_QUERY,
  SET_INTENDED_LEVEL_OF_STUDY_QUERY,
  SET_ENTRY_TERM_QUERY,
  SET_INTENDED_MAJOR_QUERY,
  SET_GPA_QUERY,
  SET_TEST_SCORES_QUERY,
  SET_DATE_REGISTERED_QUERY,
  SET_RELATIVE_ENGAGEMENT_QUERY,
  SET_TOTAL_TIME_SPENT_QUERY,
  SET_SCHEDULED_VISIT_QUERY,
  SET_APPLIED_QUERY,
  SET_ACTIVITY_WITH_INSTITUTION_QUERY,
  SET_ACTIVITY_WITH_EAB_QUERY,
  SET_LIST_MEMBERSHIP_QUERY,
  SET_LOCATIONS_QUERY,
  SET_QUERY_IS_INCONGRUENT,
} from '../actionTypes/query.actionTypes';

export interface ISetQueryAction {
  type: string;
  payload: any;
}

export function setProspectiveStudentsQuery(value: any): ISetQueryAction {
  return { type: SET_PROSPECTIVE_STUDENTS_QUERY, payload: value };
}

export function setParentsOfProspectsQuery(value: any): ISetQueryAction {
  return { type: SET_PARENTS_OF_PROSPECTS_QUERY, payload: value };
}

export function setOtherQuery(value: any): ISetQueryAction {
  return { type: SET_OTHER_QUERY, payload: value };
}

export function setUSAQuery(value: any): ISetQueryAction {
  return { type: SET_USA_QUERY, payload: value };
}

export function setInternationalQuery(value: any): ISetQueryAction {
  return { type: SET_INTERNATIONAL_QUERY, payload: value };
}

export function setAgeQuery(value: any): ISetQueryAction {
  return { type: SET_AGE_QUERY, payload: value };
}

export function setGenderQuery(value: any): ISetQueryAction {
  return { type: SET_GENDER_QUERY, payload: value };
}

export function setEthnicityQuery(value: any): ISetQueryAction {
  return { type: SET_ETHNICITY_QUERY, payload: value };
}

export function setIntendedLevelOfStudyQuery(value: any): ISetQueryAction {
  return { type: SET_INTENDED_LEVEL_OF_STUDY_QUERY, payload: value };
}

export function setEntryTermQuery(value: any): ISetQueryAction {
  return { type: SET_ENTRY_TERM_QUERY, payload: value };
}

export function setIntendedMajorQuery(value: any): ISetQueryAction {
  return { type: SET_INTENDED_MAJOR_QUERY, payload: value };
}

export function setGPAQuery(value: any): ISetQueryAction {
  return { type: SET_GPA_QUERY, payload: value };
}

export function setTestScoresQuery(value: any): ISetQueryAction {
  return { type: SET_TEST_SCORES_QUERY, payload: value };
}

export function setDateRegisteredQuery(value: any): ISetQueryAction {
  return { type: SET_DATE_REGISTERED_QUERY, payload: value };
}

export function setRelativeEngagementQuery(value: any): ISetQueryAction {
  return { type: SET_RELATIVE_ENGAGEMENT_QUERY, payload: value };
}

export function setTotalTimeSpentQuery(value: any): ISetQueryAction {
  return { type: SET_TOTAL_TIME_SPENT_QUERY, payload: value };
}

export function setScheduledVisitQuery(value: any): ISetQueryAction {
  return { type: SET_SCHEDULED_VISIT_QUERY, payload: value };
}

export function setAppliedQuery(value: any): ISetQueryAction {
  return { type: SET_APPLIED_QUERY, payload: value };
}

export function setActivityWithInstitutionQuery(value: any): ISetQueryAction {
  return { type: SET_ACTIVITY_WITH_INSTITUTION_QUERY, payload: value };
}

export function setActivityWithEABQuery(value: any): ISetQueryAction {
  return { type: SET_ACTIVITY_WITH_EAB_QUERY, payload: value };
}

export function setListMembershipQuery(value: any): ISetQueryAction {
  return { type: SET_LIST_MEMBERSHIP_QUERY, payload: value };
}

export function setLocationsQuery(value: any): ISetQueryAction {
  return { type: SET_LOCATIONS_QUERY, payload: value };
}

export interface ISetQueryIsIncongruentAction {
  type: string;
  payload: boolean;
}

export function setQueryIsIncongruent(
  value: boolean
): ISetQueryIsIncongruentAction {
  return { type: SET_QUERY_IS_INCONGRUENT, payload: value };
}
try {
    // @ts-ignore
    setProspectiveStudentsQuery.displayName = "setProspectiveStudentsQuery";
    // @ts-ignore
    setProspectiveStudentsQuery.__docgenInfo = { "description": "", "displayName": "setProspectiveStudentsQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setProspectiveStudentsQuery"] = { docgenInfo: setProspectiveStudentsQuery.__docgenInfo, name: "setProspectiveStudentsQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setProspectiveStudentsQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setParentsOfProspectsQuery.displayName = "setParentsOfProspectsQuery";
    // @ts-ignore
    setParentsOfProspectsQuery.__docgenInfo = { "description": "", "displayName": "setParentsOfProspectsQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setParentsOfProspectsQuery"] = { docgenInfo: setParentsOfProspectsQuery.__docgenInfo, name: "setParentsOfProspectsQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setParentsOfProspectsQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setOtherQuery.displayName = "setOtherQuery";
    // @ts-ignore
    setOtherQuery.__docgenInfo = { "description": "", "displayName": "setOtherQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setOtherQuery"] = { docgenInfo: setOtherQuery.__docgenInfo, name: "setOtherQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setOtherQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setUSAQuery.displayName = "setUSAQuery";
    // @ts-ignore
    setUSAQuery.__docgenInfo = { "description": "", "displayName": "setUSAQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setUSAQuery"] = { docgenInfo: setUSAQuery.__docgenInfo, name: "setUSAQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setUSAQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setInternationalQuery.displayName = "setInternationalQuery";
    // @ts-ignore
    setInternationalQuery.__docgenInfo = { "description": "", "displayName": "setInternationalQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setInternationalQuery"] = { docgenInfo: setInternationalQuery.__docgenInfo, name: "setInternationalQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setInternationalQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setAgeQuery.displayName = "setAgeQuery";
    // @ts-ignore
    setAgeQuery.__docgenInfo = { "description": "", "displayName": "setAgeQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setAgeQuery"] = { docgenInfo: setAgeQuery.__docgenInfo, name: "setAgeQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setAgeQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGenderQuery.displayName = "setGenderQuery";
    // @ts-ignore
    setGenderQuery.__docgenInfo = { "description": "", "displayName": "setGenderQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setGenderQuery"] = { docgenInfo: setGenderQuery.__docgenInfo, name: "setGenderQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setGenderQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setEthnicityQuery.displayName = "setEthnicityQuery";
    // @ts-ignore
    setEthnicityQuery.__docgenInfo = { "description": "", "displayName": "setEthnicityQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setEthnicityQuery"] = { docgenInfo: setEthnicityQuery.__docgenInfo, name: "setEthnicityQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setEthnicityQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setIntendedLevelOfStudyQuery.displayName = "setIntendedLevelOfStudyQuery";
    // @ts-ignore
    setIntendedLevelOfStudyQuery.__docgenInfo = { "description": "", "displayName": "setIntendedLevelOfStudyQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setIntendedLevelOfStudyQuery"] = { docgenInfo: setIntendedLevelOfStudyQuery.__docgenInfo, name: "setIntendedLevelOfStudyQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setIntendedLevelOfStudyQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setEntryTermQuery.displayName = "setEntryTermQuery";
    // @ts-ignore
    setEntryTermQuery.__docgenInfo = { "description": "", "displayName": "setEntryTermQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setEntryTermQuery"] = { docgenInfo: setEntryTermQuery.__docgenInfo, name: "setEntryTermQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setEntryTermQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setIntendedMajorQuery.displayName = "setIntendedMajorQuery";
    // @ts-ignore
    setIntendedMajorQuery.__docgenInfo = { "description": "", "displayName": "setIntendedMajorQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setIntendedMajorQuery"] = { docgenInfo: setIntendedMajorQuery.__docgenInfo, name: "setIntendedMajorQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setIntendedMajorQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGPAQuery.displayName = "setGPAQuery";
    // @ts-ignore
    setGPAQuery.__docgenInfo = { "description": "", "displayName": "setGPAQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setGPAQuery"] = { docgenInfo: setGPAQuery.__docgenInfo, name: "setGPAQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setGPAQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setTestScoresQuery.displayName = "setTestScoresQuery";
    // @ts-ignore
    setTestScoresQuery.__docgenInfo = { "description": "", "displayName": "setTestScoresQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setTestScoresQuery"] = { docgenInfo: setTestScoresQuery.__docgenInfo, name: "setTestScoresQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setTestScoresQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setDateRegisteredQuery.displayName = "setDateRegisteredQuery";
    // @ts-ignore
    setDateRegisteredQuery.__docgenInfo = { "description": "", "displayName": "setDateRegisteredQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setDateRegisteredQuery"] = { docgenInfo: setDateRegisteredQuery.__docgenInfo, name: "setDateRegisteredQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setDateRegisteredQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setRelativeEngagementQuery.displayName = "setRelativeEngagementQuery";
    // @ts-ignore
    setRelativeEngagementQuery.__docgenInfo = { "description": "", "displayName": "setRelativeEngagementQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setRelativeEngagementQuery"] = { docgenInfo: setRelativeEngagementQuery.__docgenInfo, name: "setRelativeEngagementQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setRelativeEngagementQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setTotalTimeSpentQuery.displayName = "setTotalTimeSpentQuery";
    // @ts-ignore
    setTotalTimeSpentQuery.__docgenInfo = { "description": "", "displayName": "setTotalTimeSpentQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setTotalTimeSpentQuery"] = { docgenInfo: setTotalTimeSpentQuery.__docgenInfo, name: "setTotalTimeSpentQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setTotalTimeSpentQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setScheduledVisitQuery.displayName = "setScheduledVisitQuery";
    // @ts-ignore
    setScheduledVisitQuery.__docgenInfo = { "description": "", "displayName": "setScheduledVisitQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setScheduledVisitQuery"] = { docgenInfo: setScheduledVisitQuery.__docgenInfo, name: "setScheduledVisitQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setScheduledVisitQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setAppliedQuery.displayName = "setAppliedQuery";
    // @ts-ignore
    setAppliedQuery.__docgenInfo = { "description": "", "displayName": "setAppliedQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setAppliedQuery"] = { docgenInfo: setAppliedQuery.__docgenInfo, name: "setAppliedQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setAppliedQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setActivityWithInstitutionQuery.displayName = "setActivityWithInstitutionQuery";
    // @ts-ignore
    setActivityWithInstitutionQuery.__docgenInfo = { "description": "", "displayName": "setActivityWithInstitutionQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setActivityWithInstitutionQuery"] = { docgenInfo: setActivityWithInstitutionQuery.__docgenInfo, name: "setActivityWithInstitutionQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setActivityWithInstitutionQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setActivityWithEABQuery.displayName = "setActivityWithEABQuery";
    // @ts-ignore
    setActivityWithEABQuery.__docgenInfo = { "description": "", "displayName": "setActivityWithEABQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setActivityWithEABQuery"] = { docgenInfo: setActivityWithEABQuery.__docgenInfo, name: "setActivityWithEABQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setActivityWithEABQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setListMembershipQuery.displayName = "setListMembershipQuery";
    // @ts-ignore
    setListMembershipQuery.__docgenInfo = { "description": "", "displayName": "setListMembershipQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setListMembershipQuery"] = { docgenInfo: setListMembershipQuery.__docgenInfo, name: "setListMembershipQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setListMembershipQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setLocationsQuery.displayName = "setLocationsQuery";
    // @ts-ignore
    setLocationsQuery.__docgenInfo = { "description": "", "displayName": "setLocationsQuery", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setLocationsQuery"] = { docgenInfo: setLocationsQuery.__docgenInfo, name: "setLocationsQuery", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setLocationsQuery" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setQueryIsIncongruent.displayName = "setQueryIsIncongruent";
    // @ts-ignore
    setQueryIsIncongruent.__docgenInfo = { "description": "", "displayName": "setQueryIsIncongruent", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setQueryIsIncongruent"] = { docgenInfo: setQueryIsIncongruent.__docgenInfo, name: "setQueryIsIncongruent", path: "src/shared/containers/Filter/actionCreators/query.actionCreators.ts#setQueryIsIncongruent" };
}
catch (__react_docgen_typescript_loader_error) { }